import { useContextState } from "../../../../hooks/theme"


export const useStyles = () => {
  const { colors: color } = useContextState()

  return ({
    closeSuccess: { //ready
      position: 'absolute',
      right: '10px',
      top: '5px',
    },
    containerSuccess: { //ready
      width: '100%',
      margin: 'auto',
      padding: '32px',
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      justifyContent: 'center',
      '& .container': {
        //border:'1px solid red',
        borderBottom: `1px solid ${color.color13}`,
        padding: '10px 20px 20px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      /* '& .MuiTypography-root': {
        width: 'fit-content',
        textAlign: 'center',
      },*/
      '& .title': {
        fontSize: '18px',
        color: color.primary,
        //fontWeight: '800',
      },
      '& .description': {
        fontSize: '14px',
        color: color.color9,
      },
      '& .icon': {
        svg: {
          color: color.primary,
          fontSize:'2.5rem'
        }
      },
      '& .iconGradient': {
        '& .MuiSvgIcon-root': {
          fontSize: '2em'
        }
      }
    },
    butonContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: '20px 8px',
      borderBottom: `1px solid ${color.color13}`,
    },
    w10: {
      width: '10%'
    },
    w74: {
      width: '79%'
    },
    w15: {
      width: '10%',
    }
  })
}
